__turbopack_context__.v({
  "container": "header-module-scss-module__jvolgG__container",
  "logo": "header-module-scss-module__jvolgG__logo",
  "top-bar": "header-module-scss-module__jvolgG__top-bar",
});
